import React from "react";
import { Link, useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";

export default function AdminDataPermissions() {
  const history = useHistory();

  const table_columns = [{ header: "Name", key: "name" }];

  const table_actions = (data_permission) => (
    <ul id="action-menu" className="action-menu">
      <Link
        to={"/admin-data-permission-form#data_permission_id=" + data_permission.id}
      >
        {" "}
        <i className="bi bi-pencil"></i>Edit
      </Link>
    </ul>
  );

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  function onClickNew(ev) {
    ev.stopPropagation();
    history.push("/admin-data-permission-form");
  }

  return (
    <div className="page admin-page admin-data-permissions-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"></i> Admin
        </button>
        <h1>Data Permissions</h1>
        <i className="spacer" />
        <button className="new-button" onClick={onClickNew}>
          New Data Permission
        </button>
      </div>
      <div className="data-permissions">
        <DataTable
          query="reference/permissions/listData"
          cols={table_columns}
          actions={table_actions}
          empty="No Data Permissions Found"
        />
      </div>
    </div>
  );
}
